import styles from "./DetailsSection.module.scss";

import { useTranslation } from "react-i18next";

import { AppDropdown } from "@/modules/shared/components/AppDropdown";

import { CameraIconSvg } from "../../svgs/CameraIconSvg";
import { ClockIconSvg } from "../../svgs/ClockIconSvg";
import { PlanetIconSvg } from "../../svgs/PlanetIconSvg";
import { TimezoneOption } from "../../types/TimezoneOption";
import { DetailsRow } from "../DetailsRow";

type Props = {
  timezone: TimezoneOption | undefined;
  localizedTimezoneOptions: TimezoneOption[];
  setTimezoneOption: (option: TimezoneOption) => void;
  disableTimezoneSelection?: boolean;
};

// width must match .detailsSection max-width in BookingWidget.module.scss (300px / 18.75rem)
const DROPDOWN_STYLES = {
  marginLeft: -30,
  width: 300,
};

export const DetailsSection = ({
  timezone,
  localizedTimezoneOptions,
  setTimezoneOption,
  disableTimezoneSelection = false,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.detailsList}>
      <DetailsRow icon={<PlanetIconSvg />}>
        <AppDropdown
          marginLeft={DROPDOWN_STYLES.marginLeft}
          width={DROPDOWN_STYLES.width}
          selectedOption={timezone}
          options={localizedTimezoneOptions}
          onSelect={setTimezoneOption}
          testId="timezone-select"
          disabled={disableTimezoneSelection}
        />
      </DetailsRow>
      <DetailsRow icon={<ClockIconSvg />}>
        <span className={styles.detailsLabel}>
          {t("bookingWidget.sessionDuration")}
        </span>
      </DetailsRow>
      <DetailsRow icon={<CameraIconSvg />}>
        <span className={styles.detailsLabel}>
          {t("bookingWidget.sessionDescription")}
        </span>
      </DetailsRow>
    </div>
  );
};
